import { url } from "api";
import JSZip from "jszip";

export const extractImageFromZip = async (uri) => {
  try {
    if (!uri || uri.split(".").pop() !== "gz") {
      return uri; // plain image URL
    }
    const res = await fetch(`${url}/uploads/${uri}`);
    const buf = await res.arrayBuffer();
    const zip = await JSZip.loadAsync(buf);

    const image = Object.keys(zip.files).find(f => /\.(jpe?g|png|gif)$/i.test(f));
    if (!image) return uri;

    const blob = await zip.file(image).async("blob");
    return URL.createObjectURL(blob); // <-- string
  } catch {
    return uri;
  }
};
